


















import { NO_LIMIT } from '@ad/tt_ads_common_enums';
import { computed, defineComponent, PropType } from '@vue/composition-api';
import { NetWorkOptionsType } from '../types';

const name = 'ttam-network';
export default defineComponent({
  name,
  props: {
    value: {
      type: Array as PropType<string[]>,
      required: true,
    },
    options: {
      type: Array as PropType<NetWorkOptionsType[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const _network = computed({
      get: () => props.value,
      set: val => {
        let newVal = val;
        const len = newVal?.length ?? 0;
        if (!len) {
          return;
        }
        // 选择不限时，清空其他限制条件
        if (len > 1) {
          const lastChecked = newVal[len - 1];
          if (lastChecked === NO_LIMIT) {
            newVal = [NO_LIMIT];
          } else {
            if (newVal.includes(NO_LIMIT)) {
              newVal = newVal.filter(item => item !== NO_LIMIT);
            }
          }
        }
        emit('input', newVal);
        emit('change', newVal);
      },
    });
    return {
      _network,
    };
  },
});
